<template>
    <section class="section">
        <footer class="is-full-width">
          <div class="is-pulled-left">
            <a href="mailto:mathewmoose95@gmail.com">
                <font-awesome-icon :icon="['fal', 'at']" key='icon'/>
            </a>
            <a href="https://www.linkedin.com/in/mathew-moose-b6b874133/" target="_blank">
                <font-awesome-icon :icon="['fab', 'linkedin-in']" key='icon'/>
            </a>
            <a href="https://github.com/XMoose25X" target="_blank">
                <font-awesome-icon :icon="['fab', 'github']" key='icon'/>
            </a>
            <a href="https://codepen.io/XMoose25X/" target="_blank">
                <font-awesome-icon :icon="['fab', 'codepen']" key='icon'/>
            </a>
          </div>
          <div id="copyright" class="is-pulled-right">{{copyright}}</div>
        </footer>
    </section>
</template>

<script>
export default {
  data: function () {
    return {
      home: false,
      about: false,
      copyright: '© ' + new Date().getFullYear() + ' Mathew Moose'
    }
  },
  methods: {
    mouseEnter: function (type) {
      this.about = true
    }
  }
}
</script>
<style scoped>
a {
  color: white;
  padding: 0px 0.5em;
}
a:hover *{
    color: cyan;
    transition: color 0.2s linear;
}
#copyright{
  font-size: 12px;
  height: 24px;
  line-height: 24px;
}
footer{
  width: 100%;
  color: white;
  cursor: default;
}
.section{
  padding-top: 0px;
  padding-bottom: 0px;
  background-color: #2e2e2e;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue